import styled from 'styled-components';

export const Container = styled.div`
  .confirm-body {
    color: ${(props) => props.theme.$gray900};
  }

  .confirm-body p:last-of-type {
    margin-bottom: 0;
  }
`;
